import { ContactData } from 'types';

export const getFormattedAddress = (data?: ContactData) => {
  const { street, outdoorNumber, indoorNumber, suburb, zipCode } = data || {};

  if (indoorNumber)
    return `${street} #${outdoorNumber}, ${indoorNumber}, ${suburb} C.P. ${zipCode}`;
  return `${street} #${outdoorNumber}, ${suburb} C.P. ${zipCode}`;
};
